<!-- 签到、签退表单 -->
<template>
    <layui-collapse ref="collapse" class="requestForm">
        <div class="layui-colla-item">
            <h2 class="layui-colla-title">签到签退服务信息</h2>
            <div class="layui-colla-content layui-show">
                <div class="layui-form-item-two layui-form-column">
                  <div class="layui-form-colun-inner">
                    <div class="layui-form-item-left">
                        <div class="layui-form-item">
                            <label class="layui-form-label">工程师：</label>
                            <label class="layui-form-label right">{{editRow.SIGNIN_TIME ? editRow.ENGINEER_NAME : ''}}</label>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">签到时间：</label>
                            <label class="layui-form-label right">{{editRow.SIGNIN_TIME}}</label>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">签到坐标：</label>
                            <label class="layui-form-label right">{{editRow.SIGNIN_TIME ? editRow.SIGNIN_LOCATION : ''}}</label>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">签到地址：</label>
                            <label class="layui-form-label right">{{editRow.SIGNIN_ADDRESS}}</label>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">签到距离(km)：</label>
                            <label class="layui-form-label right">{{SIGNIN_DISTANCE}}</label>
                        </div>
                        <div class="layui-form-item" v-if="editRow.SIGNIN_EXCEPTION_REASON">
                            <label class="layui-form-label">签到异常原因：</label>
                            <label class="layui-form-label right textarea">{{editRow.SIGNIN_EXCEPTION_REASON}}</label>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">签到备注：</label>
                            <label class="layui-form-label right textarea">{{editRow.SIGNIN_REMARKS}}</label>
                        </div>
                        <!-- <div class="layui-form-item">
                            <label class="layui-form-label">签到图片：</label>
                            <div class="layui-input-inline" style="width:auto">
                                <layui-imgupload
                                    v-model="editRow.SIGNIN_FILE_IS"
                                    :enabled="false">
                                </layui-imgupload>
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">签到视频：</label>
                            <div class="layui-input-inline" style="width:auto">
                            </div>
                        </div> -->
                    </div>
                    <div class="layui-form-item-right">
                        <div class="layui-form-item">
                            <label class="layui-form-label">处理时长(h)：</label>
                            <label class="layui-form-label right">{{editRow.PROCESSING_TIME}}</label>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">补贴时长(h)：</label>
                            <label class="layui-form-label right">{{editRow.ALLOWANCE_TIME}}</label>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">签退时间：</label>
                            <label class="layui-form-label right">{{editRow.SIGNOUT_TIME}}</label>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">签退坐标：</label>
                            <label class="layui-form-label right">{{editRow.SIGNOUT_TIME ? editRow.SIGNOUT_LOCATION : ''}}</label>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">签退地址：</label>
                            <label class="layui-form-label right">{{editRow.SIGNOUT_ADDRESS}}</label>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">签退距离(km)：</label>
                            <label class="layui-form-label right">{{SIGNOUT_DISTANCE}}</label>
                        </div>
                        <div class="layui-form-item" v-if="editRow.SIGNOUT_EXCEPTION_REASON">
                            <label class="layui-form-label">签退异常原因：</label>
                            <label class="layui-form-label right textarea">{{editRow.SIGNOUT_EXCEPTION_REASON}}</label>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">签退备注：</label>
                            <label class="layui-form-label right textarea">{{editRow.SIGNOUT_REMARKS}}</label>
                        </div>
                        <!-- <div class="layui-form-item">
                            <label class="layui-form-label">签退图片：</label>
                            <div class="layui-input-inline" style="width:auto">
                                <layui-imgupload
                                    v-model="editRow.SIGNOUT_FILE_IS"
                                    :enabled="false">
                                </layui-imgupload>
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label">签退视频：</label>
                            <div class="layui-input-inline" style="width:auto">
                            </div>
                        </div> -->
                    </div>
                  </div>
                  <div class="layui-form-bottom">
                    <div class="layui-form-item">
                        <label class="layui-form-label">签到附件：</label>
                        <div class="layui-input-inline"   style="width:80%">
                              <layui-listfileupload v-model="editRow.SIGNIN_FILE_FS" targetEl=".requestForm"></layui-listfileupload>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">签退附件：</label>
                        <div class="layui-input-inline"   style="width:80%">
                              <layui-listfileupload v-model="editRow.SIGNOUT_FILE_FS" targetEl=".requestForm"></layui-listfileupload>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </layui-collapse>
</template>
<script>
    export default {
        props: {
            editRow: {
                default: () => ({}),
                type: Object
            },
        },
        data () {
            return {
                SIGNIN_DISTANCE: '',
                SIGNOUT_DISTANCE: '',
            }
        },
        mounted () {
           //米转换公里
           if(this.editRow){
                this.SIGNIN_DISTANCE = this.editRow.SIGNIN_DISTANCE ? (this.editRow.SIGNIN_DISTANCE / 1000).toFixed(4) : '';
                this.SIGNOUT_DISTANCE = this.editRow.SIGNOUT_DISTANCE ? (this.editRow.SIGNOUT_DISTANCE / 1000).toFixed(4) : '';
           }else{
               this.SIGNIN_DISTANCE = this.editRow.SIGNIN_DISTANCE;
               this.SIGNOUT_DISTANCE = this.editRow.SIGNOUT_DISTANCE;
           }
        },
        watch:{
            'editRow.SIGNIN_DISTANCE':function(val,oldval){
                this.SIGNIN_DISTANCE = val ? (val / 1000).toFixed(4) : '';
            },
            'editRow.SIGNOUT_DISTANCE':function(val,oldval){
                this.SIGNOUT_DISTANCE = val ? (val / 1000).toFixed(4) : '';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/workOrder/detailForm/signInOutForm.vue